import styled from '@emotion/styled';

export const RescheduleCard = styled.div`
  border-radius: 0 0 0.5rem 0.5rem;
  border-top: none;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem 1rem 1.5rem 1rem;
`;

export const RescheduleWrapper = styled.div<{ noPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: ${props => (props.noPadding ? '0' : '1rem')};
  ::-webkit-scrollbar {
    display: none;
  }
`;
